<template>
  <b-modal
    id="add-or-update-event-center"
    :visible="isAddOrUpdateActive"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    @hidden="resetForm"
    @hide="resetForm"
    @change="(val) => $emit('update:is-add-or-update-active', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1" style="border-bottom: 1px solid #000000;">
          <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%;">
            {{ isUpdate ? 'Update' : 'Add New' }}
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <validation-observer
          #default="{ handleSubmit }"
          ref="update_modal_form"
        >
          <b-form
            class="my-1"
            @submit.prevent="handleSubmit(onCreateOrUpdate)"
            @reset.prevent="resetForm"
          >

            <b-alert
              v-if="errorMessage"
              variant="danger"
              :show="true"
            >
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>

            <validation-provider
              #default="validationContext"
              name="Job Title"
              rules="required"
            >
              <b-form-group
                label="Job title"
                label-for="job_title"
              >
                <template #label>
                  <span>Job title<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-input
                  id="job_title"
                  v-model="new_data.job_title"
                  autofocus
                  trim
                  placeholder="Ex: Lead Software Engineer"
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Employment type"
              rules="required"
            >
              <b-form-group
                label="Employment type"
                label-for="employment_type"
              >
                <template #label>
                  <span>Employment type<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-select
                  id="employment_type"
                  v-model="new_data.employment_type"
                  :options="employment_types"
                  placeholder="Please select"
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Name of company"
              rules="required"
            >
              <b-form-group
                label="Name of company"
                label-for="name_of_company"
              >
                <template #label>
                  <span>Name of company<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-input
                  id="name_of_company"
                  v-model="new_data.name_of_company"
                  trim
                  placeholder="Ex: Workers GH"
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Location"
              rules=""
            >
              <b-form-group
                label="Location"
                label-for="location"
              >
                <b-form-input
                  id="location"
                  v-model="new_data.location"
                  trim
                  placeholder="Ex: Accra, Ghana"
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-if="new_data.location"
              #default="validationContext"
              name="Location type"
              rules="required"
            >
              <b-form-group
                label="Location type"
                label-for="location_type"
              >
                <template #label>
                  <span>Location type<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-select
                  id="location_type"
                  v-model="new_data.location_type"
                  :options="location_types"
                  placeholder="Please select"
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            
            <validation-provider
              #default="validationContext"
              name="Responsibilities"
            >
              <b-form-group
                label="Responsibilities"
                label-for="responsibilities"
              >
                <template #label>
                  <span>Responsibilities</span>
                </template>

                <b-form-textarea
                  id="responsibilities"
                  v-model="new_data.responsibilities"
                  trim
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="This is a secondment"
              rules=""
            >
              <b-form-group
                label="This is a secondment"
                label-for="is_secondment"
              >
                <b-form-checkbox
                  id="is_secondment"
                  v-model="new_data.is_secondment"
                  placeholder=""
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="I am currently working here"
              rules=""
            >
              <b-form-group
                label="I am currently working here"
                label-for="is_current_work"
              >
                <b-form-checkbox
                  id="is_current_work"
                  v-model="new_data.is_current_work"
                  placeholder=""
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              name="Start date"
              rules="required"
            >
              <b-form-group
                label="Start date"
                label-for="start_date"
              >
                <template #label>
                  <span>Start date<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-datepicker
                  id="date_started"
                  v-model="new_data.date_started"
                  value-as-date
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              v-if="!new_data.is_current_work"
              #default="validationContext"
              name="Start date"
              :rules="!new_data.is_secondment ? 'required' : ''"
            >
              <b-form-group
                label="Start date"
                label-for="date_ended"
              >
                <template #label>
                  <span>End date<sup v-if="!new_data.is_secondment" style="color: tomato">*</sup></span>
                </template>

                <b-form-datepicker
                  id="date_ended"
                  v-model="new_data.date_ended"
                  :min="new_data.date_started"
                  value-as-date
                  :disabled="disableForm"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
                :disabled="disableForm"
              >
                {{ isUpdate ? 'Update' : 'Add' }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>

<script>
import {
  BOverlay, BSidebar, BForm, BFormGroup, BFormInput, 
  BFormTextarea, BFormInvalidFeedback, BButton, BFormSelect,
  BAlert, BCardText, BModal, BFormCheckbox, BFormDatepicker,
  BFormFile
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { get, cloneDeep, omit } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { addDays, isAfter, addMonths, endOfMonth } from 'date-fns/esm';

import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

const rawFormData = {
  employment_type: "",
  name_of_company: "",
  location: "",
  location_type: "",
  responsibilities: "",
  is_current_work: false,
  date_started: "",
  date_ended: "",
  is_secondment: false,
}

export default {
  components: {
    BFormFile,
    BForm,
    BAlert,
    BModal,
    BButton,
    vSelect,
    BOverlay,
    BSidebar,
    BCardText,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormDatepicker,
    BFormInvalidFeedback,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddOrUpdateActive',
    event: 'update:is-add-or-update-active',
  },
  props: {
    isAddOrUpdateActive: {
      type: Boolean,
      required: true,
    },
    updateData: {
      type: Object,
      default: null,
      required: false
    },
    userId: {
      type: String,
      required: false,
      default: ""
    },
    isPersonal: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      required,
      loading: false,
      errorMessage: "",
      employment_types: [
        "Full-time",
        "Part-time",
        "Contract",
        "Self-employed",
        "Temporary",
        "Freelance",
        "Internship",
        "Remote",
        "Volunteer"
      ].map(type => ({ text: type, value: type })),
      location_types: [
        "On-site",
        "Hybrid",
        "Remote",
      ].map(type => ({ text: type, value: type })),

      new_data: cloneDeep(rawFormData),
      editing_attachments: [],
      attachments: []
    }
  },
  computed: {
    isUpdate(){
      return !!this.updateData
    },
    disableForm(){
      return false
    },
  },
  watch: {
    updateData: {
      handler(updateData){
        if (updateData){
          this.new_data = {
            _id: updateData._id,
            job_title: updateData.job_title,
            employment_type: updateData.employment_type,
            name_of_company: updateData.name_of_company,
            location: updateData.location,
            location_type: updateData.location_type,
            responsibilities: updateData.responsibilities,
            is_current_work: updateData.is_current_work,
            date_started: updateData.date_started,
            date_ended: updateData.date_ended,
            reason_for_leaving: updateData.reason_for_leaving || "",
            is_secondment: updateData.is_secondment,
          }
        }
      },
      immediate: true,
      deep: true
    },
    'new_data.date_started': {
      handler(date_started){
        const { date_ended } = this.new_data;
        if (date_ended){
          if (isAfter(new Date(date_started), new Date(date_ended))){
            this.new_data.date_ended = addDays(new Date(date_started), 1)
          }
        } else if (!this.new_data.is_current_work){
          this.new_data.date_ended = endOfMonth(addMonths(new Date(date_started), 1))
        }
      }
    }
  },
  methods: {
    async onCreateOrUpdate(){
      try {
        this.loading = true;
        this.errorMessage = "";

        const success = await this.$refs.update_modal_form.validate();
        if (!success){
          return;
        }

        const messages = {
          update: {
            title: "Confirm Update",
            text: "Proceed to update record?",
            icon: "warning"
          },
          new: {
            title: "Create",
            text: "Proceed to create new record?",
            icon: "info"
          }
        }

        /* eslint-disable no-nested-ternary */
        const message = this.isUpdate ? messages.update : messages.new;
        const { title, text, icon } = message;

        const result = await this.$swal({
          title,
          text,
          icon,
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed.',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          return;
        }

        const update_data = omit(this.new_data, ["_id", "attachments"]);
        const id = this.new_data._id

        const formData = new FormData()
        Object.keys(update_data).forEach((field) => {
          formData.append(field, update_data[field])
        })

        const apiService = this.isPersonal ? this.useJwt().mainService.userWorkHistory : this.useJwt().mainService.workHistory;
        
        if (this.isUpdate){
          await apiService.update(id, formData);
        } else {
          if (this.userId){
            formData.append("user_id", this.userId)
          }
          await apiService.create(formData);
        }
        this.$emit("refetchData");
        this.$emit('update:is-add-or-update-active', false);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'AlertQuestionIcon',
            variant: 'success',
            text: `${this.isUpdate ? 'Updated' : 'Added'} successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.$emit("resetUpdateData")
      this.new_data = {};
      if (this.$refs.update_modal_form) {
        this.$refs.update_modal_form.reset()
      }
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-or-update-event-center {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
